import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import SearchIcon from "@mui/icons-material/Search";
import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Switch,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { EditButton, List, useDataGrid } from "@refinedev/mui";
import { RemoveButton } from "components/buttons/remove";
import React, { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import UserStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/userStatus";
import { RecycleButton } from "components/buttons/recycle";
import "./style.css";
import { DeleteButton } from "components/buttons/delete";

export const ProdCategoriesList = () => {
  const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
    filters: {
      initial: [
        {
          field: "activeStatus",
          operator: "eq",
          value: 0,
        },
      ],
    },
    sorters: {
      initial: [
        {
          field: "updatedAt",
          order: "desc",
        },
      ],
    },
    pagination: {
      pageSize: 10,
    },
  });

  const viewBoolean = (param: boolean) => {
    return (
      <>
        {param ? (
          <CheckIcon style={{ color: "green" }} />
        ) : (
          <ClearIcon style={{ color: "grey" }} />
        )}
      </>
    );
  };

  const getRowClassName = (params: any) => {
    switch (params.row.activeStatus) {
      case 1:
        return "row-disable";
      default:
        return "";
    }
  };

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 100,
        hideable: false,
      },
      {
        field: "crmId",
        headerName: "CRM Product ID",
        minWidth: 150,
        hideable: false,
      },
      {
        field: "name",
        headerName: "Name",
        minWidth: 200,
        flex: 1,
        hideable: false,
      },
      {
        field: "description",
        headerName: "Description",
        minWidth: 350,
        flex: 1,
        hideable: false,
      },
      {
        field: "isWarriorPro",
        headerName: "IsWarriorPro",
        minWidth: 100,
        flex: 1,
        hideable: false,
        renderCell: function render({ row }) {
          return viewBoolean(row.isWarriorPro);
        },
      },
      {
        field: "activeStatus",
        headerName: "Status",
        minWidth: 100,
        hideable: false,
        renderCell: function render({ row }) {
          return UserStatus.fromValue(row.activeStatus)?.name;
        },
      },
      {
        field: "createdAt",
        headerName: "CreatedAt",
        minWidth: 200,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.createdAt) {
            return new Date(row.createdAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "updatedAt",
        headerName: "UpdatedAt",
        minWidth: 200,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.updatedAt) {
            return new Date(row.updatedAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        hideable: false,
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              {row.activeStatus ? (
                <>
                  <RecycleButton hideText recordItemId={row.id} />
                  <DeleteButton hideText recordItemId={row.id} />
                </>
              ) : (
                <RemoveButton hideText recordItemId={row.id} />
              )}
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 100,
      },
    ],
    []
  );

  // search parts
  const [crmId, setCrmId] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [id, setId] = useState("");
  const [activeStatus, setActiveStatus] = useState(0);
  const handleFilter = () => {
    setCurrent(1);
    setPageSize(10);
    let searchArr: { field: string; value: string; operator: string }[] = [];
    if (crmId) {
      searchArr.push({
        field: "crmId[$ilike]",
        value: `%${crmId}%`,
        operator: "eq",
      });
    }
    if (name) {
      searchArr.push({
        field: "name[$ilike]",
        value: `%${name}%`,
        operator: "eq",
      });
    }
    if (description) {
      searchArr.push({
        field: "description[$ilike]",
        value: `%${description}%`,
        operator: "eq",
      });
    }
    if (id) {
      searchArr.push({
        field: "id",
        value: `${id}`,
        operator: "eq",
      });
    }
    if (activeStatus || activeStatus === 0) {
      searchArr.push({
        field: "activeStatus",
        value: `${activeStatus}`,
        operator: "eq",
      });
    }
    setFilters(searchArr as any);
  };

  const clearFun = () => {
    setCrmId("");
    setDescription("");
    setId("");
    setName("");
    setActiveStatus(0);
    setFilters([
      {
        field: "activeStatus",
        value: 0,
        operator: "eq",
      },
    ]);
  };
  return (
    <List>
      <FormControlLabel
        label=""
        style={{ width: "100%" }}
        control={
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <TextField
                id="standard-basic"
                label="Id"
                variant="standard"
                value={id}
                onChange={(e) => setId(e.target.value)}
                style={{ width: "30%" }}
              />
              <TextField
                id="standard-basic"
                label="CRM Product ID"
                variant="standard"
                value={crmId}
                onChange={(e) => setCrmId(e.target.value)}
                style={{ width: "30%" }}
              />
              <TextField
                id="standard-basic"
                label="Name"
                variant="standard"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ width: "30%" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <TextField
                id="standard-basic"
                label="Description"
                variant="standard"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                style={{ width: "30%" }}
              />
              <FormControl style={{ width: "30%" }}>
                <InputLabel id="action">Status : </InputLabel>
                <Select
                  labelId="action"
                  value={activeStatus as any}
                  label="ActiveStatus"
                  variant="standard"
                  onChange={(event: SelectChangeEvent) => {
                    setActiveStatus(event.target.value as any);
                  }}
                >
                  {Object.values(UserStatus)[0].map((item: any) => {
                    return (
                      <MenuItem key={item.value} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <div style={{ width: "30%" }}>
                <ClearOutlinedIcon onClick={clearFun} />
                <SearchIcon onClick={handleFilter} />
              </div>
            </div>
          </div>
        }
      />
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        paginationMode="server"
        rowsPerPageOptions={[10, 20, 50]}
        disableColumnFilter
        getRowClassName={getRowClassName}
      />
    </List>
  );
};
